module.exports = __webpack_public_path__ + "static/media/magnet.3de313f6.svg";